import React, { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { LuSparkles, LuWorkflow, LuWand2, LuSearch, LuX } from "react-icons/lu";
import { SCROLL_CLASS, SCROLL_CSS } from "./BotCard";

const NEW_BOT_CSS = `
.su-nb { width: 960px; max-width: 100%; height: min(680px, calc(100vh - 48px)); display: flex; flex-direction: column; overflow: hidden; border: 1px solid var(--su-line); border-radius: 16px; background: var(--su-surface); box-shadow: var(--su-shadow); }
.su-nb-h { display: flex; align-items: center; gap: 10px; min-height: 64px; padding: 0 12px 0 20px; border-bottom: 1px solid var(--su-line-2); flex-shrink: 0; }
.su-nb-h h2 { flex: 1; margin: 0; font-family: var(--su-font); font-size: 19px; font-weight: 600; color: var(--su-ink); }
.su-nb-x { width: 38px; height: 38px; display: grid; place-items: center; border: none; border-radius: 10px; background: none; color: var(--su-ink); cursor: pointer; }
.su-nb-x:hover { background: var(--su-raised); }
.su-nb-body { flex: 1; min-height: 0; display: grid; grid-template-columns: minmax(0, 1fr) 300px; }
.su-nb-main { min-height: 0; overflow-y: auto; padding: 18px 20px; }
.su-nb-side { min-height: 0; overflow-y: auto; display: flex; flex-direction: column; gap: 16px; padding: 18px 20px; border-left: 1px solid var(--su-line); background: var(--su-bg); }
.su-nb-sect { margin: 18px 0 8px; font-size: 11.5px; font-weight: 600; letter-spacing: 0.05em; text-transform: uppercase; color: var(--su-ink-3); }
.su-nb-sect.first { margin-top: 0; }
.su-nb-starts, .su-nb-tpls { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; }
.su-nb-opt { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; min-width: 0; padding: 12px; border: 1px solid var(--su-line); border-radius: 12px; background: var(--su-surface); color: var(--su-ink); text-align: left; cursor: pointer; }
.su-nb-opt:hover { border-color: var(--su-control); }
.su-nb-opt.on { border-color: var(--su-accent-ink); background: var(--su-chip-on); }
.su-nb-opt b { max-width: 100%; font-size: 14.5px; font-weight: 600; color: var(--su-ink); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.su-nb-opt small { font-size: 12.5px; line-height: 1.4; color: var(--su-ink-3); display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.su-nb-head { display: flex; align-items: center; justify-content: space-between; gap: 8px; width: 100%; }
.su-nb-ic { width: 30px; height: 30px; display: grid; place-items: center; border-radius: 8px; color: #ffffff; flex-shrink: 0; }
.su-nb-thumb { display: flex; align-items: center; justify-content: center; gap: 5px; width: 100%; height: 56px; overflow: hidden; border-radius: 8px; background: var(--su-raised); }
.su-nb-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.su-nb-thumb i { display: block; width: 26px; height: 16px; border-radius: 4px; }
.su-nb-thumb u { display: block; width: 8px; height: 1px; background: var(--su-control); }
.su-nb-count { font-size: 12px; color: var(--su-ink-3); white-space: nowrap; }
.su-nb-title { display: flex; align-items: center; justify-content: space-between; gap: 8px; width: 100%; }
.su-nb-title b { min-width: 0; }
.su-kit .su-nb-search { width: 100%; flex: none; height: 38px; margin-bottom: 10px; }
.su-nb-none { font-size: 13px; color: var(--su-ink-3); }
.su-nb-f { display: flex; flex-direction: column; gap: 4px; }
.su-nb-f label, .su-nb-f > span { margin: 0; font-size: 12px; font-weight: 600; color: var(--su-ink-3); }
.su-kit .su-nb-f input { width: 100%; padding: 7px 2px; border: none !important; border-bottom: 1px solid var(--su-line) !important; border-radius: 0; outline: none; box-shadow: none !important; background: transparent !important; color: var(--su-ink) !important; font-family: inherit; font-size: 14.5px; font-weight: 400; }
.su-kit .su-nb-f input:focus { border-bottom-color: var(--su-sky) !important; }
.su-kit .su-nb-f input.bad { border-bottom-color: var(--su-red) !important; }
.su-kit .su-nb-f textarea { width: 100%; padding: 9px 11px; border: 1px solid var(--su-line) !important; border-radius: 10px; outline: none; box-shadow: none !important; background: var(--su-surface) !important; color: var(--su-ink) !important; font-family: inherit; font-size: 14px; line-height: 1.45; resize: none; }
.su-kit .su-nb-f textarea:focus { border-color: var(--su-sky) !important; }
.su-kit .su-nb-f textarea::placeholder { color: var(--su-ink-3); font-style: normal; }
.su-nb-err { font-size: 12px; color: var(--su-red-ink); }
.su-nb-seg { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; margin-top: 2px; }
.su-nb-seg button { padding: 8px; border: 1px solid var(--su-line); border-radius: 9px; background: var(--su-surface); color: var(--su-ink-2); font-size: 13px; font-weight: 600; cursor: pointer; }
.su-nb-seg button.on { border-color: var(--su-accent-ink); background: var(--su-chip-on); color: var(--su-accent-ink); }
.su-nb-hint { font-size: 12px; line-height: 1.45; color: var(--su-ink-3); }
.su-nb-foot { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 20px; border-top: 1px solid var(--su-line-2); flex-shrink: 0; }
@media (max-width: 760px) {
    .su-nb-body { grid-template-columns: minmax(0, 1fr); overflow-y: auto; }
    .su-nb-main, .su-nb-side { overflow-y: visible; }
    .su-nb-side { border-left: none; border-top: 1px solid var(--su-line); }
    .su-nb-starts, .su-nb-tpls { grid-template-columns: minmax(0, 1fr); }
}
`;

const STARTS = [
    {
        kind: "agent",
        title: "Agente IA",
        text: "Conversa en lenguaje natural y usa herramientas.",
        icon: LuSparkles,
        color: "#7563D8",
        badge: "Recomendado",
    },
    {
        kind: "scratch",
        title: "Desde cero",
        text: "Diseña el flujo nodo por nodo.",
        icon: LuWorkflow,
        color: "#0a7ba5",
    },
    {
        kind: "ai",
        title: "Generar flujo con IA",
        text: "Describe lo que necesitas y la IA arma los nodos.",
        icon: LuWand2,
        color: "#7c5cd6",
    },
];

const TYPES = [
    { value: "linear", label: "Lineal" },
    { value: "transactional", label: "Transaccional" },
];

const normalize = (text) =>
    String(text || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "");

const uniqueName = (base, existing) => {
    const taken = existing.filter((name) => String(name || "").includes(base)).length;
    return taken ? `${base} ${taken + 1}` : base;
};

const TemplateThumb = ({ template }) => {
    const [failed, setFailed] = useState(false);
    if (template?.image && !failed) {
        return (
            <span className="su-nb-thumb">
                <img src={template.image} alt="" loading="lazy" onError={() => setFailed(true)} />
            </span>
        );
    }
    const shown = (template?.nodes || []).slice(0, 3);
    return (
        <span className="su-nb-thumb">
            {shown.length === 0 && <span className="su-nb-count">Sin nodos</span>}
            {shown.map((node, index) => (
                <React.Fragment key={node.id || index}>
                    {index > 0 && <u />}
                    <i style={{ backgroundColor: node?.data?.color || "#5DCCED" }} />
                </React.Fragment>
            ))}
        </span>
    );
};

const NewBotModal = ({ open, onClose, templates = [], existingNames = [], scratchNodes = [], onCreate, onGenerateAI }) => {
    const [selection, setSelection] = useState({ kind: "agent" });
    const [name, setName] = useState("");
    const [nameTouched, setNameTouched] = useState(false);
    const [description, setDescription] = useState("");
    const [type, setType] = useState("linear");
    const [query, setQuery] = useState("");
    const [error, setError] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!open) return;
        setSelection({ kind: "agent" });
        setName("Asistente IA");
        setNameTouched(false);
        setDescription("");
        setType("linear");
        setQuery("");
        setError("");
        setSaving(false);
    }, [open]);

    useEffect(() => {
        if (!open) return undefined;
        const onKey = (event) => event.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    const filteredTemplates = useMemo(() => {
        const q = normalize(query.trim());
        return (templates || []).filter((item) => !q || normalize(`${item.name} ${item.description}`).includes(q));
    }, [templates, query]);

    if (!open) return null;

    const choose = (next) => {
        setSelection(next);
        setError("");
        if (next.kind === "template") {
            setType(next.template?.type || "linear");
            if (!nameTouched) {
                setName(uniqueName(next.template?.name || "Bot", existingNames));
                setDescription(next.template?.description || "");
            }
        } else if (!nameTouched) {
            setName(next.kind === "agent" ? "Asistente IA" : "");
            setDescription("");
        }
    };

    const submit = async () => {
        if (selection.kind === "ai") {
            onGenerateAI();
            return;
        }
        if (!name.trim()) {
            setError("Ponle un nombre al bot.");
            return;
        }
        const graph =
            selection.kind === "scratch"
                ? { nodes: scratchNodes, edges: [] }
                : selection.kind === "template"
                ? { nodes: selection.template?.nodes || [], edges: selection.template?.edges || [] }
                : { nodes: [], edges: [] };
        setSaving(true);
        try {
            await onCreate({
                values: { nameBot: name.trim(), descriptionBot: description.trim(), botType: selection.kind === "agent" ? "linear" : type },
                graph,
                agent: selection.kind === "agent",
            });
        } finally {
            setSaving(false);
        }
    };

    return createPortal(
        <div className="su-kit su-scrim" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
            <style>{SCROLL_CSS}</style>
            <style>{NEW_BOT_CSS}</style>
            <div className="su-nb" role="dialog" aria-modal="true" aria-label="Nuevo bot">
                <div className="su-nb-h">
                    <h2>Nuevo bot</h2>
                    <button type="button" className="su-nb-x" aria-label="Cerrar" onClick={onClose}>
                        <LuX className="su-ic" size={18} />
                    </button>
                </div>

                <div className="su-nb-body">
                    <div className={`su-nb-main ${SCROLL_CLASS}`}>
                        <div className="su-nb-sect first">¿Cómo quieres empezar?</div>
                        <div className="su-nb-starts">
                            {STARTS.map((start) => {
                                const selected = selection.kind === start.kind;
                                const Icon = start.icon;
                                return (
                                    <button key={start.kind} type="button" aria-pressed={selected} className={`su-nb-opt${selected ? " on" : ""}`} onClick={() => choose({ kind: start.kind })}>
                                        <span className="su-nb-head">
                                            <span className="su-nb-ic" style={{ backgroundColor: start.color }}>
                                                <Icon className="su-ic" size={16} />
                                            </span>
                                            {start.badge && <span className="su-tag ai">{start.badge}</span>}
                                        </span>
                                        <b>{start.title}</b>
                                        <small>{start.text}</small>
                                    </button>
                                );
                            })}
                        </div>

                        <div className="su-nb-sect">O usa una plantilla</div>
                        <div className="su-search su-nb-search">
                            <LuSearch className="su-ic" size={16} />
                            <input
                                type="text"
                                id="new-bot-template-search"
                                value={query}
                                onChange={(event) => setQuery(event.target.value)}
                                placeholder="Buscar plantilla por nombre o descripción"
                                aria-label="Buscar plantilla por nombre o descripción"
                            />
                        </div>
                        {filteredTemplates.length === 0 ? (
                            <span className="su-nb-none">{templates.length ? "No hay plantillas con ese nombre." : "Aún no hay plantillas disponibles."}</span>
                        ) : (
                            <div className="su-nb-tpls">
                                {filteredTemplates.map((item) => {
                                    const selected = selection.kind === "template" && selection.template?._id === item._id;
                                    const count = Array.isArray(item.nodes) ? item.nodes.length : 0;
                                    return (
                                        <button key={item._id} type="button" aria-pressed={selected} className={`su-nb-opt${selected ? " on" : ""}`} onClick={() => choose({ kind: "template", template: item })}>
                                            <TemplateThumb template={item} />
                                            <span className="su-nb-title">
                                                <b title={item.name}>{item.name}</b>
                                                <span className="su-nb-count">
                                                    {count} nodo{count === 1 ? "" : "s"}
                                                </span>
                                            </span>
                                            <small>{item.description}</small>
                                        </button>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    <aside className={`su-nb-side ${SCROLL_CLASS}`} aria-label="Tu bot">
                        {selection.kind === "ai" ? (
                            <div className="su-nb-hint">En el siguiente paso describes tu bot y la IA arma el flujo.</div>
                        ) : (
                            <>
                                <div className="su-nb-f">
                                    <label htmlFor="new-bot-name">Nombre</label>
                                    <input
                                        id="new-bot-name"
                                        type="text"
                                        className={error ? "bad" : ""}
                                        value={name}
                                        onChange={(event) => {
                                            setName(event.target.value);
                                            setNameTouched(true);
                                            setError("");
                                        }}
                                    />
                                    {error && <span className="su-nb-err">{error}</span>}
                                </div>
                                <div className="su-nb-f">
                                    <label htmlFor="new-bot-description">Descripción (opcional)</label>
                                    <textarea id="new-bot-description" rows={3} value={description} onChange={(event) => setDescription(event.target.value)} placeholder="Para qué sirve este bot" />
                                </div>
                            </>
                        )}

                        {(selection.kind === "scratch" || selection.kind === "template") && (
                            <>
                                <div className="su-nb-f">
                                    <span>Tipo de bot</span>
                                    <div className="su-nb-seg">
                                        {TYPES.map((option) => (
                                            <button key={option.value} type="button" aria-pressed={type === option.value} className={type === option.value ? "on" : ""} onClick={() => setType(option.value)}>
                                                {option.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="su-nb-hint">Lineal sigue los pasos en orden. Transaccional responde a eventos de otro sistema.</div>
                            </>
                        )}

                        {selection.kind === "agent" && <div className="su-nb-hint">Con Agente IA no eliges tipo de flujo: la IA atiende los mensajes y los eventos de webhook siguen por nodos.</div>}
                    </aside>
                </div>

                <div className="su-nb-foot">
                    <button type="button" className="su-btn ghost" onClick={onClose}>
                        Cancelar
                    </button>
                    <button type="button" className="su-btn" onClick={submit} disabled={saving}>
                        {selection.kind === "ai" ? "Continuar" : saving ? "Creando…" : "Crear bot"}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default NewBotModal;
